import * as actions from './actions'

// initial state
const state = {
  chargeMenu: [
    {
      sort_number: 0,
      charge_value: 0,
      default_payment: 0
    }
  ]
}

// getters
const getters = {
  chargeMenu: (state) => {
    return state.chargeMenu
  }
}

// mutations
const mutations = {
  SET_CHARGE_MENU (state, data) {
    state.chargeMenu = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
